/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllBusinessesResponse } from '../models/AllBusinessesResponse';
import type { AnalyzeSocialDto } from '../models/AnalyzeSocialDto';
import type { AnalyzeWebsiteDto } from '../models/AnalyzeWebsiteDto';
import type { BusinessEntity } from '../models/BusinessEntity';
import type { CheckFacebookPageDto } from '../models/CheckFacebookPageDto';
import type { CheckInstagramHandleDto } from '../models/CheckInstagramHandleDto';
import type { CreateBusinessDto } from '../models/CreateBusinessDto';
import type { DownloadLogoDto } from '../models/DownloadLogoDto';
import type { SigninUserResponseDto } from '../models/SigninUserResponseDto';
import type { UpdateBrandKitDto } from '../models/UpdateBrandKitDto';
import type { UpdateBusinessDto } from '../models/UpdateBusinessDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessesService {
    /**
     * Create a new business
     * @param requestBody
     * @returns BusinessEntity
     * @throws ApiError
     */
    public static businessControllerCreateV1(
        requestBody: CreateBusinessDto,
    ): CancelablePromise<BusinessEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List businesses for current user
     * @returns AllBusinessesResponse
     * @throws ApiError
     */
    public static businessControllerFindMyBusinessesV1(): CancelablePromise<AllBusinessesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/businesses',
        });
    }
    /**
     * Update current business
     * @param requestBody
     * @returns BusinessEntity
     * @throws ApiError
     */
    public static businessControllerUpdateV1(
        requestBody: UpdateBusinessDto,
    ): CancelablePromise<BusinessEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/businesses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete current business and return tokens scoped to the next-best business (or PENDING_BUSINESS_ID if none left)
     * @returns SigninUserResponseDto
     * @throws ApiError
     */
    public static businessControllerDeleteV1(): CancelablePromise<SigninUserResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/businesses',
        });
    }
    /**
     * Get brand kit for current business
     * @returns any Brand kit (full object)
     * @throws ApiError
     */
    public static businessControllerGetBrandKitV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/businesses/brand-kit',
        });
    }
    /**
     * Update brand kit (partial, field-level save)
     * @param requestBody
     * @returns any Updated brand kit
     * @throws ApiError
     */
    public static businessControllerPatchBrandKitV1(
        requestBody: UpdateBrandKitDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/businesses/brand-kit',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Flip setupCompletedAt so a draft business (created via add-another-business) becomes visible. Idempotent.
     * @param id
     * @returns BusinessEntity
     * @throws ApiError
     */
    public static businessControllerCompleteSetupV1(
        id: string,
    ): CancelablePromise<BusinessEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/{id}/complete-setup',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Leave current business and return tokens scoped to the next-best business (or PENDING_BUSINESS_ID if none left)
     * @returns SigninUserResponseDto
     * @throws ApiError
     */
    public static businessControllerLeaveV1(): CancelablePromise<SigninUserResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/leave',
        });
    }
    /**
     * Check if a website URL is reachable (HEAD request)
     * @param requestBody
     * @returns any Reachability result
     * @throws ApiError
     */
    public static businessControllerCheckUrlV1(
        requestBody: AnalyzeWebsiteDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/check-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests - rate limit exceeded`,
            },
        });
    }
    /**
     * Extract social handles linked from a website's HTML — used to cross-verify what a user typed during onboarding
     * @param requestBody
     * @returns any Social handles map
     * @throws ApiError
     */
    public static businessControllerFindSocialsV1(
        requestBody: AnalyzeWebsiteDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/find-socials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests - rate limit exceeded`,
            },
        });
    }
    /**
     * Check if a Facebook handle points to a valid Page
     * @param requestBody
     * @returns any Facebook page check result
     * @throws ApiError
     */
    public static businessControllerCheckFacebookPageV1(
        requestBody: CheckFacebookPageDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/check-facebook-page',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests - rate limit exceeded`,
            },
        });
    }
    /**
     * Stream a brand scan (SSE) — screenshot + Gemini extraction
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static businessControllerScanV1(
        requestBody: AnalyzeSocialDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/scan',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Check if an Instagram handle is a valid Business/Creator account
     * @param requestBody
     * @returns any Handle check result
     * @throws ApiError
     */
    public static businessControllerCheckInstagramHandleV1(
        requestBody: CheckInstagramHandleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/check-instagram-handle',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List Facebook pages managed by the current user
     * @returns any List of Facebook pages
     * @throws ApiError
     */
    public static businessControllerListFacebookPagesV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/businesses/facebook-pages',
        });
    }
    /**
     * Download a logo from URL and store as attachment
     * @param requestBody
     * @returns any Logo downloaded and stored
     * @throws ApiError
     */
    public static businessControllerDownloadLogoV1(
        requestBody: DownloadLogoDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/download-logo',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Download failed`,
            },
        });
    }
}
